import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field"]

  toggle(event) {
    this.fieldTargets.forEach((target) => {
        if (event.target.checked) {
          target.setAttribute("disabled", true);
        } else {
          target.removeAttribute("disabled");
        }
    });
  }
}
